import { FilterOutlined } from "@ant-design/icons";
import { MazakaButton } from "./MazakaButton";
import { FC } from "react";

interface MazakaDetailsFilterButtonProps{
    setIsShowDetailsFilter:React.Dispatch<React.SetStateAction<boolean>>
    buttonBlock?:boolean
}


const MazakaDetailsFilterButton:FC<MazakaDetailsFilterButtonProps >= (props) => {
    return ( <>
    <MazakaButton
              className="!bg-black !text-white !text-[10px] !p-2 md:!p-4 md:!text-sm "
              type="primary"
              icon={<FilterOutlined />}
           
              onClick={() => {
                props.setIsShowDetailsFilter(true);
              }}
              block={props.buttonBlock}
            >
              {"Detaylı Filtre"}
            </MazakaButton>
    </> );
}
 
export default MazakaDetailsFilterButton;